module.exports = require('./lib/page-content');
